import { getAuth, GoogleAuthProvider, User } from 'firebase/auth';
import { getFunctions, httpsCallable } from 'firebase/functions';
import firebaseApp from './firebase-config';
import { AuthLoginPrams } from './use-auth';
import { LoginActionType } from 'app/Pages/LoginPage';

const firebaseAuth = getAuth(firebaseApp);

export const googleProvider = new GoogleAuthProvider();

/**
 * Workaround to handle `PostLogin` action
 * @param user
 */
export async function handlePostLogin(
    user: User,
    params?: AuthLoginPrams,
    organization?: string,
    action?: LoginActionType,
) {
    const functions = getFunctions();
    const postLogin = httpsCallable(functions, 'postLogin');
    let postLoginResp = null;
    try {
        postLoginResp = await postLogin({
            organization: {
                id: params?.authorizationParams?.organization || organization,
            },
            action,
        });

        await user.getIdToken(true);

        const tokenResult = await user.getIdTokenResult();
        const { claims } = tokenResult;

        if (params) {
            const { authorizationParams } = params;
            if (authorizationParams) {
                const { organization } = authorizationParams;
                const userOrgs = claims.organizations as string[];
                if (!userOrgs.includes(organization) && !claims.superAdmin) {
                    await firebaseAuth.signOut();
                    const errorMessage =
                        'Access Denied: user does not belong to organization';
                    console.log(errorMessage);
                    throw new Error(errorMessage);
                }
            }
        }
    } catch (error) {
        console.error('Error post login:', error.message);
        console.error('Error post login response:', postLoginResp);
        throw error;
    }
}

export default firebaseAuth;
